export default __webpack_public_path__ + "static/media/leaderboard-start-active.732ed8b3.svg";